// Preserve the original 760-unit layout proportions on a 102mm label.
export const receiptSize = (size: number) => `${(size / 760) * 102}mm`
